import { Button, Dropdown, MeetingActiveIcon, MeetingDefaultIcon } from '@bp/ui-components';
import styles from '../_Flyouts.module.scss';
import { useAuthClaims } from '../../../../hooks/useAuthClaims';
import { MeetingsFlyout } from '../../../MeetingFlyout/MeetingsFlyout';
import { useRunningPlannedMeetings } from '../../../../hooks/useCalendarEvents';
import { UseQueryExecute } from 'urql';
import { FragmentType, getFragmentData, graphql } from 'client/gql';

const HeaderMeetingsFlyoutFieldsDocument = graphql(`
  fragment HeaderMeetingsFlyoutFields on Query {
    ...CalendarEventMapCalendarEventsToBpEventTypeFields
    ...MeetingsFlyoutFields
  }
`);

const HeaderMeetingsFlyout = ({
  query,
  refetch,
}: {
  query: FragmentType<typeof HeaderMeetingsFlyoutFieldsDocument> | undefined;
  refetch: UseQueryExecute;
}) => {
  const fragment = getFragmentData(HeaderMeetingsFlyoutFieldsDocument, query);

  const { pimAuthClaims } = useAuthClaims();
  const { runningMeetings } = useRunningPlannedMeetings({
    profileUuid: pimAuthClaims.getProfile().uuid,
    query: fragment,
    refetch,
  });

  return (
    <Dropdown
      noPadding
      className={styles['flyout']}
      trigger={
        <Button
          hierarchy='tertiary'
          icon={runningMeetings.length > 0 ? <MeetingActiveIcon /> : <MeetingDefaultIcon />}
        />
      }
    >
      <MeetingsFlyout query={fragment} refetchEvents={refetch} />
    </Dropdown>
  );
};

export { HeaderMeetingsFlyout };
